module.exports = __webpack_public_path__ + "static/philosophy_bg-a9013693c210c468fc94f016b17836ae.png";